import { RefreshCwIcon } from 'lucide-react'

export const upcomingRxServices = [
  {
    title: 'Medicine refill',
    description: 'Request a refill for your regular medicines.',
    icon: RefreshCwIcon,
  },
] as const
